import React from 'react'
import { ROS_GROUPS } from '../../../utils';

const ROS = (props) => {
  let { widgetsPreviewData: Data } = props;
  let noValExistText = <p className="text ar-light-color">No data recorded</p>;

  const removeTrailingEmptyLines = (html) => {
    return html.replace(/(<p><br><\/p>\s*)+$/g, '');
  }

  let reviewOfSystemData = Data?.ReviewOfSystem;
  let reviewOfSystemNotesText = removeTrailingEmptyLines(Data?.ReviewOfSystemNotes || '');

  const isVisuallyEmpty = (html = '') => {
    return html.replace(/<[^>]*>/g, '').trim() === '';
  }
  return (
    <div className="d-flex gap-10">
      <div className="ar-form-counter flex-center">
        <p className='text text-black'>{props?.itemCount}</p>
      </div>
      <div className='observation-content d-flex flex-column gap-2 w-100'>
        <div className='d-flex flex-column gap-6'>
          <p class="heading fs-13">Review of System(ROS)</p>
          {/* {["Fields", "Both"].includes(defaultSelectedItems.reviewOfSystemType) && */}
          <div className="">
            <p className='heading d-flex align-itemes-center gap-1 flex-wrap'>
              {(() => {
                const visibleGroups = ROS_GROUPS.map(group => ({
                  ...group,
                  selectedItems: group.items.filter(
                    item => reviewOfSystemData?.[item.key] === "true"
                  ),
                })).filter(group => group.selectedItems.length > 0);

                return visibleGroups?.length > 0 ?
                  visibleGroups.map((group, groupIndex) => (
                    <React.Fragment key={group.title}>
                      {group.title}:{" "}
                      <span className="text">
                        {group.selectedItems.map((item, itemIndex) => (
                          <React.Fragment key={item.key}>
                            {item.label}
                            {itemIndex < group.selectedItems.length - 1 && ", "}
                          </React.Fragment>
                        ))}
                        {groupIndex < visibleGroups.length - 1 ? ", " : ""}
                      </span>
                    </React.Fragment>
                  )) : noValExistText
              })()}
            </p>
          </div>
          {/* } */}
        </div>
        {/* {["FreeText", "Both"].includes(defaultSelectedItems.reviewOfSystemType) && */}
        <div className='d-flex flex-column gap-6'>
          {/* {["Both"].includes(defaultSelectedItems.reviewOfSystemType) &&  */}
          <p className='heading fs-13'>ROS Notes</p>
          {/* } */}
          {isVisuallyEmpty(Data.ReviewOfSystemNotes) ?
            noValExistText :
            <p className="text" dangerouslySetInnerHTML={{ __html: reviewOfSystemNotesText }}></p>}
        </div>
        {/* } */}
      </div>
    </div>
  )
}

export default ROS